import { Box, Stack, Typography } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";
import { PropsWithChildren, ReactNode } from "react";

type Props = {
    title?: string;
    titleVariant?: Variant;
    actions?: ReactNode;
};

export default function GaiaPageGridComponent({
    title = undefined,
    titleVariant = "h1",
    actions = undefined,
    children,
}: PropsWithChildren<Props>) {
    return (
        <Box>
            <Stack
                direction="row"
                gap={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "end",
                    gap: 2,
                }}
            >
                {title && (
                    <Typography variant={titleVariant} sx={{ flex: 1 }}>
                        {title}
                    </Typography>
                )}
                {actions}
            </Stack>
            {children}
        </Box>
    );
}
